const Icon = ({ src, alt }) => {
  return (
    <img
      className='proyect__icon'
      src={src}
      alt={alt}
      title={alt}
    />
  )
}

export default Icon
